export default {
  title: 'Actions',
  description: 'Action management for incident response',
  create: 'Create Action',
  noResults: 'No actions found',
  stats: {
    total: 'Total',
    pending: 'Pending',
    inProgress: 'In Progress',
    completed: 'Completed',
    overdue: 'Overdue'
  },
  filters: {
    status: 'Status',
    priority: 'Priority',
    type: 'Type'
  },
  fields: {
    title: 'Title',
    status: 'Status',
    priority: 'Priority',
    type: 'Type',
    progress: 'Progress',
    assignedTo: 'Assigned To',
    dueDate: 'Due Date',
    description: 'Description',
    incident: 'Related Incident'
  },
  status: {
    pending: 'Pending',
    in_progress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled'
  },
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical'
  },
  type: {
    corrective: 'Corrective',
    preventive: 'Preventive',
    improvement: 'Improvement'
  },
  sort: {
    'createdAt-desc': 'Most Recent',
    'createdAt-asc': 'Oldest',
    'dueDate-desc': 'Due Date (Latest)',
    'dueDate-asc': 'Due Date (Earliest)',
    'priority-desc': 'Priority (High to Low)',
    'priority-asc': 'Priority (Low to High)',
    'progress-desc': 'Progress (High to Low)',
    'progress-asc': 'Progress (Low to High)'
  },
  kanban: {
    noActions: 'No actions'
  },
  view: {
    list: 'List view',
    kanbanStatus: 'Kanban by status',
    kanbanPriority: 'Kanban by priority'
  }
}
